import React from 'react';
import { logout } from "../actions/auth";
import { eUserType } from 'constants.js';
import { getProviderPermittedPaths } from 'routes/dashboard';

export default function withAuth(WrapComponent, userDetail) {
  return class extends React.PureComponent {
    componentDidMount() {
      const userSub = localStorage.getItem('userSub');
      const isProvider = userDetail?.userType === eUserType.provider && !userDetail?.providerInformation?.isAdmin;
      const providerRole = userDetail?.providerInformation?.roles ?? '';

      if (
        !userSub
        || (userDetail
          && isProvider
          && !getProviderPermittedPaths(providerRole).some((route) =>
            this.props.history.location.pathname.includes(
              route.split('/:')[0]
            )
          ))
      ) {
        logout(this.props.history);
      }
    }

    render() {
      return <WrapComponent {...this.props} />
    }
  };
}
